import type { WalletConnectParameters } from 'wagmi/connectors'

import { DESCRIPTION, SITE_LOGO, SITE_NAME, SITE_URL, WALLET_CONNECT_PROJECT_ID } from '@src/configs/metadata'

export const defaultWalletConnectConfig: WalletConnectParameters = {
    projectId: WALLET_CONNECT_PROJECT_ID,
    metadata: {
        name: SITE_NAME,
        description: DESCRIPTION,
        url: SITE_URL,
        icons: [SITE_LOGO],
    },
    qrModalOptions: {
        themeVariables: {
            '--wcm-z-index': '3000',
        },
    },
}
